import { TextInput } from "@freightsimple/ui-core/Controls/TextInput";
import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";

interface CardholderNameProps {
  cardholderName: string;
  onCardholderNameChanged: (_: string) => void;
  errorMessage: ErrorMessageType;
  validated: boolean;
}

// The label + error live on the wrapping FormItem (CreditCardsCardPanel); this just
// renders the ui-core boxed input.
function CreditCardsCardholderName(props: CardholderNameProps) {
  return (
    <TextInput
      data-testid="cardholder-name"
      value={props.cardholderName}
      onChange={(e) => props.onCardholderNameChanged(e.target.value)}
    />
  );
}
export default CreditCardsCardholderName;
